// extracted by mini-css-extract-plugin
module.exports = {"friend":"friendlink-module--friend--2WnR4"};